module.exports = __webpack_public_path__ + "img/profile_default.48f38673.svg";